import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import BoilingWater from '../../../svg/BoilingWater.js';

class AlmostDone extends Component {
  state = {};
  render() {
    return (
      <InfoBox
        headline="Almost done!"
        subline="Just a little housekeeping so we can send you a chef."
        icon={<BoilingWater />}
      />
    );
  }
}

export default AlmostDone;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/AlmostDone.js